import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class SongsService {

  constructor(private httpClient: HttpClient) { }
  //songVMList = new Observable<SongVM[]>();

  get(): Observable<SongVM[]> {
    return this.httpClient.get<SongVM[]>(Constants.songs);
  }
}

export class SongVM {
  songsid: number;
  title: string;
  url: string;
  isactive: boolean;
  constructor(songsid: number,
    title: string,
    url: string,
    isactive: boolean) {
    this.isactive = isactive;
    this.title = title;
    this.songsid = songsid;
    this.url = url;
  }
}